import AbstractComponent from '~/ui/components/AbstractComponent';
import { getElements } from '~/packages/utils';
import './styles';

const CLASS_ROOT = 'am-TopNav';
const CLASS_OPEN = '-open';
const CLASS_ACTIVE = '-active';

export default class TopNav extends AbstractComponent<IParams> {

    private isOpen = false;
    private isDesktop = false;
    private dropdowns: HTMLElement[];

    public onMount(): void {
        const that = this;
        const { element } = this;
        that.dropdowns = getElements(`.${CLASS_ROOT}_links .-nested`, element)!;

        document.addEventListener('click', that.onDocClick);

        that.dropdowns
            .forEach(el => el.addEventListener('click', that.onDropdownClick));

        getElements(`.${CLASS_ROOT}_toggle`, element)
            .forEach(el => el.addEventListener('click', that.onModalToggle));

        that.locator.matchMedia.listen(that.onMedia);
    }

    public onUpdate = () => {
        this.element.classList.toggle(CLASS_OPEN, this.isOpen);
    }

    /**
     * Runs on media changes
     *
     * @param matches
     */
    protected onMedia = (matches: any) => {
        const that = this;
        const isDesktop = matches.m === true;

        // force close modal on desktop
        isDesktop && that.toggleModal(false);

        that.isDesktop = isDesktop;
        that.update();
    }

    /**
     * Handles toggle clicks
     *
     * @param e
     */
    protected onModalToggle = (e: PointerEvent) => {
        e.preventDefault();
        this.toggleModal();
    }

    /**
     * Handles submenus parent clicks
     *
     * @param e
     */
    protected onDropdownClick = (e: PointerEvent) => {
        const ct = (e.currentTarget as HTMLElement);

        if (e.target === ct) {
            e.preventDefault();
            e.stopPropagation();
            ct.classList.toggle(CLASS_ACTIVE);

            // close dropdowns that are not the current one or its children
            // it is required along with 'stopPropagation()'
            // if we want to support nested dropdowns
            this.dropdowns.forEach(
                el => ct !== el && !el.contains(ct) && el.classList.remove(CLASS_ACTIVE)
            );
        }
    }

    /**
     * Handles document clicks
     *
     * @param e
     */
    protected onDocClick = (e: PointerEvent) => {

        // close opened dropdowns except self
        this.dropdowns.forEach(el => {
            if(!el.contains(e.target as HTMLElement)) {
                el!.classList.remove(CLASS_ACTIVE);
            }
        });
    }

    /**
     * Toggles visibility of the modal
     *
     * @param force
     */
    protected toggleModal = (force?: boolean) => {
        this.isOpen = force !== undefined ? force : !this.isOpen;
        this.update();
    }
}

// this component has no parameters
interface IParams {}
